import { useEffect } from 'react';
import { useMatches } from 'react-router-dom';

export function NRDocumentTitle() {
  const matches = useMatches();

  const title = matches
    .map(match => {
      const t = match.handle?.title;
      if (!t) return null;
      return typeof t === 'function' ? t({ params: match.params }) : t;
    })
    .filter(Boolean)
    .pop();

  useEffect(() => {
    document.title = title || 'NetRise';
  }, [title]);

  return null; // this component doesn’t render anything
}
